import { Drawer, Form, Icon, Input, List, Select } from 'antd'
import { Flex, WhiteSpace, WingBlank } from 'antd-mobile'
import { formatIncompletePhoneNumber, parseIncompletePhoneNumber } from 'libphonenumber-js'
import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import { intl } from 'utils'
import messages from './messages'
import classes from './styles.module.scss'

import { mobileRule, uaeMobileRule } from 'utils/validateRules'
import { ReactComponent as DrawerCloseIcon } from '../MobilePaymentContainer/images/close.svg'
// import _ from 'lodash'

function delay(t, val) {
  return new Promise((resolve) => setTimeout(resolve, t, val))
}
class PhoneInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      queryString: '',
      // panelOpen: true,
      popupVisible: true,
    }
  }

  handleDropdownVisibleChange = async (panelOpen) => {
    const { siteConfig } = this.props
    console.log(panelOpen, 'panelOpen')
    if (this.lock) return
    if (siteConfig.isMobile && panelOpen === false) {
      if (this.firstRender) return
      await delay(300)
    }

    this.setState({ panelOpen, popupVisible: panelOpen })
  }

  handleLockClose = (e) => {
    clearTimeout(this.lock)
    this.lock = setTimeout(() => {
      this.lock = null
    }, 100)
  }

  get countries() {
    const {
      allowedCountries: { list },
    } = this.props.siteConfig
    const { queryString } = this.state
    if (!queryString) {
      return list
    }

    if (list.length > 0) {
      const result = list.filter(
        (i) =>
          i.areaCode.toLowerCase().indexOf(queryString) > -1 ||
          i.countryCode.toLowerCase().indexOf(queryString) > -1 ||
          i.countryFullName.toLowerCase().indexOf(queryString) > -1
      )
      return result
    }
    return []
  }

  firstRender = true

  countrySelectRender = (options) => {
    const { queryString, popupVisible } = this.state
    const { siteConfig, form } = this.props

    if (siteConfig.isMobile) {
      return (
        <Drawer
          placement='bottom'
          zIndex={100}
          maskClosable
          closable={false}
          visible={popupVisible}
          afterVisibleChange={() => {
            this.firstRender = false
          }}
          className={classes.countrySelectDrawer}
          onClose={() => this.setState({ popupVisible: false, panelOpen: false })}
        >
          <Flex direction='column' align='stretch' className={classes.flexContainer}>
            <WingBlank size='lg'>
              <Flex align='center' alignContent='center'>
                <Flex.Item className={classes.drawerTitle}>
                  <Flex align='center' justify='center'>
                    <span>{intl().formatMessage(messages['components.PhoneInput.picker.title'])}</span>
                  </Flex>
                  <Icon
                    className={classes.rightIcon}
                    onClick={() => {
                      this.setState({ popupVisible: false, panelOpen:false })
                    }}
                    component={DrawerCloseIcon}
                  />
                </Flex.Item>
              </Flex>
            </WingBlank>
            <WingBlank size='md'>
              <WhiteSpace size='xl' />
              <div onMouseDown={this.handleLockClose} onMouseUp={this.handleLockClose} className={classes.searchInput}>
                <Input
                  value={queryString}
                  onChange={(e) =>
                    this.setState({
                      queryString: e.target.value?.trim().toLocaleLowerCase(),
                    })}
                />
                <WhiteSpace />
              </div>
            </WingBlank>
            <Flex.Item>
              {this.countries?.map((country) => (
                <List
                  key={country.countryFullName}
                  value={country.areaCode}
                  onClick={() => {
                    if (this.lock) {
                      clearTimeout(this.lock)
                    }
                    this.handleDropdownVisibleChange(false)
                    form.setFieldsValue({ country: country.areaCode })
                  }}
                  className={classes.countryList}
                >
                  <Flex justify='between' align='center'>
                    <span>{country.countrySimpleName}</span>
                    <span className={classes.areaCode}> {country.areaCode}</span>
                  </Flex>
                </List>
              ))}
            </Flex.Item>
          </Flex>
        </Drawer>
      )
    }
    return (
      <div className={classes.dropdownPanel}>
        <div onMouseDown={this.handleLockClose} onMouseUp={this.handleLockClose} className={classes.searchInput}>
          <Input
            value={queryString}
            onChange={(e) =>
              this.setState({
                queryString: e.target.value?.trim().toLocaleLowerCase(),
              })}
          />
        </div>
        {options}
      </div>
    )
  }

  phoneInputNormalize = (value = '', prev = '') => {
    // const { form } = this.props
    // 调用国际化组件按国家/地区的格式对输入手机号格式化
    // const country = form.getFieldValue('country')
    // const countryCode = _.find(this.countries, { areaCode:country })?.countryCode
    if (value === prev) {
      return value
    }
    if (parseIncompletePhoneNumber(value) === parseIncompletePhoneNumber(prev)) {
      return parseIncompletePhoneNumber(value)
    }
    if (value?.length > 12) {
      return prev
    }
    // if (countryCode === 'AE' && value.length === 1 && value !== '0') {
    //   return formatIncompletePhoneNumber(`0${value}`, countryCode)
    // }
    return formatIncompletePhoneNumber(value)
  }

  render() {
    const { form, resetError, disableCountry = false } = this.props
    const { panelOpen, } = this.state
    return (
      <Form.Item className={classes.componentPhoneInput}>
        {form.getFieldDecorator('memberPhone', {
          ...(form.getFieldValue('country') === '+971' ? uaeMobileRule() : mobileRule()),
          validateTrigger: 'onChange',
          onChange: () => {
            resetError()
            this.props.removeCaptcha && this.props.removeCaptcha()
          },
        })(
          <Input
            size='large'
            pattern='\d*'
            onBlur={() => {
              this.props.removeCaptcha()
            }}
            inputMode='numeric' // 安卓上强制使用数字键盘
            prefix={form.getFieldDecorator('country', {
              initialValue: '+971',
              normalize: (value, prevValue, allValues) => {
                const country = this.countries.find(c => c.countryCode === value)
                return country?.areaCode || value
              },
              rules: [
                {
                  required: true,
                },
              ],
            })(
              <Select
                style={{ width: 75 }}
                className={classes.selectCountry}
                dropdownClassName={classes.selectCountryDropdown}
                onChange={() => this.setState({ queryString: null })}
                open={panelOpen}
                optionLabelProp='areacode'
                size='large'
                disabled={disableCountry}
                onDropdownVisibleChange={this.handleDropdownVisibleChange}
                dropdownRender={this.countrySelectRender}
              >
                {this.countries?.map((country) => (
                  <Select.Option key={country.countryCode} areacode={country.areaCode} value={country.countryCode}>
                    <Flex justify='between' align='center'>
                      <span>{country.countrySimpleName}</span>
                      <span> {country.areaCode}</span>
                    </Flex>
                  </Select.Option>
                ))}
              </Select>
            )}
            placeholder={intl().formatMessage(messages['components.PhoneInput.input.placeholder'])}
          />
        )}
      </Form.Item>
    )
  }
}

export default injectIntl(PhoneInput)

PhoneInput.propTypes = {
  form: PropTypes.object.isRequired,
}
